import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSendFileDialogStore = defineStore('sendFileDialog', () => {
  const isOpen = ref(false);
  const formTitle = ref<string | null>(null);
  const main_email = ref<string | null>(null);
  const main_whatsapp = ref<string | null>(null);
  const client_id = ref<number | string | null>(null);

  // Estos son FUNCIONES, no strings
  const onSendEmail = ref<null | ((emails: any[]) => Promise<any>)>(null);
  const onSendWhatsapp = ref<null | ((whatsapps: any[]) => Promise<any>)>(null);

  const openForm = (data: {
    formTitle?: string | null;
    main_email?: string | null;
    main_whatsapp?: string | null;
    client_id?: number | string | null;
    onSendEmail?: ((emails: any[]) => Promise<any>) | null;
    onSendWhatsapp?: ((whatsapps: any[]) => Promise<any>) | null;
  } = {}) => {
    formTitle.value = data.formTitle || null;
    main_email.value = data.main_email || null;
    main_whatsapp.value = data.main_whatsapp || null;
    client_id.value = data.client_id || null;
    onSendEmail.value = data.onSendEmail || null;
    onSendWhatsapp.value = data.onSendWhatsapp || null;
    isOpen.value = true;
  };

  const closeForm = () => {
    isOpen.value = false;
    formTitle.value = null;
    main_email.value = null;
    main_whatsapp.value = null;
    client_id.value = null;
    onSendEmail.value = null;
    onSendWhatsapp.value = null;
  };

  return {
    isOpen,
    openForm,
    closeForm,
    formTitle,
    main_email,
    main_whatsapp,
    client_id,
    onSendEmail,
    onSendWhatsapp,
  };
});
